/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SignupSummary,
  UserSignupStats,
} from '../models/index';
import {
    SignupSummaryFromJSON,
    SignupSummaryToJSON,
    UserSignupStatsFromJSON,
    UserSignupStatsToJSON,
} from '../models/index';

export interface DashboardApiUserSignupsListRequest {
    end?: string;
    start?: string;
}

export interface DashboardSignupSummaryRetrieveRequest {
    end?: string;
    start?: string;
}

/**
 *
 */
export class DashboardApi extends runtime.BaseAPI {

    /**
     */
    async dashboardApiUserSignupsListRaw(requestParameters: DashboardApiUserSignupsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserSignupStats>>> {
        const queryParameters: any = {};

        if (requestParameters['end'] != null) {
            queryParameters['end'] = requestParameters['end'];
        }

        if (requestParameters['start'] != null) {
            queryParameters['start'] = requestParameters['start'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/dashboard/api/user-signups/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserSignupStatsFromJSON));
    }

    /**
     */
    async dashboardApiUserSignupsList(requestParameters: DashboardApiUserSignupsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserSignupStats>> {
        const response = await this.dashboardApiUserSignupsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async dashboardSignupSummaryRetrieveRaw(requestParameters: DashboardSignupSummaryRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SignupSummary>> {
        const queryParameters: any = {};

        if (requestParameters['end'] != null) {
            queryParameters['end'] = requestParameters['end'];
        }

        if (requestParameters['start'] != null) {
            queryParameters['start'] = requestParameters['start'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/dashboard/api/user-signups/summary/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SignupSummaryFromJSON(jsonValue));
    }

    /**
     */
    async dashboardSignupSummaryRetrieve(requestParameters: DashboardSignupSummaryRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SignupSummary> {
        const response = await this.dashboardSignupSummaryRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
